// Intro fly-through ↔ titling bridge. Mutated in the camera useFrame, read by the
// DOM titling overlay via rAF — so the cinematic titles + Skip button stay in
// sync with the camera WITHOUT re-rendering React each frame.
//   active — the street fly-through is playing (overlay visible)
//   t      — progress 0..1 (drives the title phase fades)
//   skip   — Skip button sets this true; the camera jumps to the spawn
export const introBridge = { active: false, t: 0, skip: false };
